import { type FunctionComponent } from 'react';
import { useChatContext } from 'stream-chat-react';
import { assert } from 'ts-essentials';
import { useTranslation } from '../../i18n/resources';
import styles from './EmptyChannel.module.css';

export type EmptyChannelProps = {};

export const EmptyChannel: FunctionComponent<EmptyChannelProps> = () => {
  const { renderTrans, t } = useTranslation();
  const { channel } = useChatContext();
  assert(channel);
  const data = channel.data;
  assert(data);

  const { name } = data;

  return (
    <div className={styles.container}>
      <p className={styles.mainDescription}>
        {renderTrans('prayerStream', 'empty_channel_primary_description', {
          values: {
            name: name ?? '',
          },
        })}
      </p>
      <p className={styles.secondaryDescription}>
        {t('prayerStream', 'empty_channel_secondary_description')}
      </p>
    </div>
  );
};
